module.exports = __webpack_public_path__ + "img/new-offer.13608c6f.svg";